import { MutationTree } from 'vuex'
import { ITenantState } from './tenant-state.store';
import { TENANT_SET_TENANTS, TENANT_SET_BLOCK_TENANTS, TENANT_SET_BLOCK_TENANT, TENANT_LOADING } from './tenant-types.store';
import { ActivityStatus } from '../../common/enums';

export const mutations: MutationTree<ITenantState> = {
  [TENANT_LOADING]: (state: ITenantState, activityStatus: ActivityStatus) => {
    state.activityStatus = activityStatus;
  },
  [TENANT_SET_TENANTS]: (state: ITenantState, payload: {
    acitivityStatus: ActivityStatus,
    tenants: any
  }) => {
    state.tenants = payload.tenants;
    state.activityStatus = payload.acitivityStatus;
  }
  , [TENANT_SET_BLOCK_TENANTS]: (state: ITenantState, payload: {
    acitivityStatus: ActivityStatus,
    data: { total: number, data: any }
  }) => {
    state.tenants = payload.data.data;
    state.activityStatus = payload.acitivityStatus;
  }
  , [TENANT_SET_BLOCK_TENANT]: (state: ITenantState, tenant) => {
    state.activityStatus = ActivityStatus.Loaded;
    state.currentTenant = tenant;
  }
}


// WEBPACK FOOTER //
// ./src/store/tenant/tenant-mutations.store.ts